import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const organizationGeneralApi = createApi({
  reducerPath: "organizationGeneralApi",
  baseQuery,
  tagTypes: ["GeneralAddress"],
  endpoints: (builder) => ({
        
    getGeneralAddressByMasterId: builder.query({
      query: ({ id }) => {
        return `/customers/addresses/${id}`;
      },
    
      transformResponse: (response) => {
    
        const data = response?.data?.map((item) => ({
          ...item,
          id: item.customerAddressId,
        }));
    
        return data;
      },
    
      providesTags: ["GeneralAddress"],
    }),
    

    // 🔄 UPDATE entity
    updateGeneralAddress: builder.mutation({
      query: ({ id, subId, ...data }) => ({
        url: `/customers/addresses/${id}/${subId}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { customerAddresses: data }, 

      }),
      invalidatesTags: ["GeneralAddress"],
    }),

    // 🔄 DELETE entity
    deleteGeneralAddress: builder.mutation({
      query: ({ id,subId }) => ({
        url: `customers/${id}/${subId}`,
        method: "DELETE",
      }),
      invalidatesTags: ["GeneralAddress"],
    }),

    // 🔄 CREATE entity
    createGeneralAddress: builder.mutation({
      query: ({ id, ...data }) => {
        console.log("📌 createGeneralAddress triggered");
        console.log("➡️ ID used:", id);
        console.log("📝 Data sent:", data);
    
        const requestBody = { customerAddresses: data };
    
        console.log("📦 Final request body:", requestBody);
    
        return {
          url: `/customers/addresses/${id}`,
          method: "POST",
          headers: {
            "X-Request-Id": Math.random().toString(36).substring(2),
          },
          body: requestBody,
        };
      },
      invalidatesTags: ["GeneralAddress"],
    }),
    
  }),
});

export const {
  useGetGeneralAddressByMasterIdQuery,
  useLazyGetGeneralAddressByMasterIdQuery,
  useUpdateGeneralAddressMutation,
  useDeleteGeneralAddressMutation,
  useCreateGeneralAddressMutation,
} = organizationGeneralApi;
